import { COLORS } from '@repo/design-system/index'
import { QIcon_chevron_left } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorDiscussionInstructionBody = dynamic(
  () => import('../../new-portal/ai-tutor/AITutorDiscussionInstruction'),
  {
    loading: () => (
      <div className="flex h-screen w-screen items-center justify-center">
        <LoadingSpinner lg show primary />
      </div>
    ),
  }
)

const AITutorDiscussionInstructionTobNav = () => {
  const { useAITutorFlow } = useAITutorStack()
  const { push } = useAITutorFlow()
  const appRouter = useAppRouter({ stackPush: push, browserDetect: true })
  const { t } = useTranslation()

  return (
    <div className="flex w-screen flex-row items-center justify-start py-[12px] px-[20px]">
      <div className="">
        <QIcon_chevron_left width={'24px'} height={'24px'} color={COLORS.BLACK} onClick={() => appRouter.back()} />
      </div>
    </div>
  )
}

const AITutorDiscussionInstructionActivity: ActivityComponentType = () => {
  const router = useAppRouter()
  const courseId = router.query?.courseId

  return (
    <WebviewStackContainer height="52px" title={<AITutorDiscussionInstructionTobNav />} border={false}>
      <AITutorDiscussionInstructionBody courseId={courseId} />
    </WebviewStackContainer>
  )
}

export default AITutorDiscussionInstructionActivity
